'use client'

import { uniqueId } from 'lodash'
import React from 'react'

import { cn } from '@src/utils/tailwind'

import { IconText } from '../IconText/IconText'

export const Columns = ['1', '2', '3', '4', '5'] as const

interface OfferCheckProps {
  items?: Array<{ value?: string }>
  checkColor?: string
  columns?: (typeof Columns)[number]
}

export const OfferSubtitleChecks = (props: OfferCheckProps) => {
  const { items = [], checkColor = '#8DE341', columns = '2' } = props

  return (
    <div
      className={cn('mx-auto grid grid-cols-1 gap-2', {
        'lg:grid-cols-1': columns === '1',
        'lg:grid-cols-2': columns === '2',
        'lg:grid-cols-3': columns === '3',
        'lg:grid-cols-4': columns === '4',
        'lg:grid-cols-5': columns === '5',
      })}
    >
      {items?.map(({ value }) => (
        <IconText iconColor={checkColor} iconName="CheckCircleIcon" key={uniqueId()}>
          <div
            className="text-left text-body-md"
            dangerouslySetInnerHTML={{ __html: value ?? '' }}
          />
        </IconText>
      ))}
    </div>
  )
}
